export default __webpack_public_path__ + "c4b07affc1f2f4959d32f5006dd99a7c.png";